import { AccountSettingsActionsType } from "../const/actionsType";
import { AccountSettingsResponseModel } from "../reducers/accountSettings";

export const loadAccountSettings = () => ({
    type: AccountSettingsActionsType.LOAD_ACCOUNT_SETTINGS,
});

export type SetAccountSettings = ReturnType<typeof setAccountSettings>;
export const setAccountSettings = (value: AccountSettingsResponseModel) =>
    ({
        type: AccountSettingsActionsType.SET_ACCOUNT_SETTINGS,
        value,
    } as const);

export type UpdateAccountCurrency = ReturnType<typeof updateAccountCurrency>;
export const updateAccountCurrency = (value: number) =>
    ({
        type: AccountSettingsActionsType.UPDATE_ACCOUNT_CURRENCY_SETTINGS,
        value,
    } as const);
